import React, {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {Shell} from 'components/Shell';
import {toJS} from 'mobx';
import {AppRoutePaths} from 'routing/Routes';
import {appState} from 'store/AppStore';

export const DashboardView: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (appState.user) {
      const user = toJS(appState.user);
      !user.hasCollectorAdministratorData && navigate(AppRoutePaths.register.url);
    }
  }, [navigate]);

  return <Shell title="Dashboard">Dashboard</Shell>;
};
